import { headerSearchMobileButtonIconSX } from '@/components/content/Header/styles/search';
import SearchIcon from '@mui/icons-material/Search';
import { IconButton } from '@mui/material';

export const HeaderSearch: React.FC<{
	onOpen: React.MouseEventHandler<any>;
}> = ({ onOpen }) => (
	<IconButton id="header-search-button" onClick={onOpen} sx={{ zIndex: 999999999999999 }}>
		<SearchIcon sx={headerSearchMobileButtonIconSX} />
	</IconButton>
);
